// @flow
import { connect } from 'react-redux';
import Iphone from '../components/Iphone';

import type { RootState } from "../../../index";

function mapStateToProps(state: RootState) {
  return {
    locale: state.locale,
    localValues: state.localValues,
  }
}

export default connect(mapStateToProps)(Iphone);



// WEBPACK FOOTER //
// ./src/modules/custom-products/Iphone/container/IphoneContainer.js